export const getEntityId = (entity) => entity?._id ?? entity?.id ?? '';

export const getEntityName = (entity) =>
  entity?.name ?? entity?.displayName ?? entity?.title ?? 'Unknown';
